const header = {
    home: 'ראשי',
    about: 'מי אני',
    projects: 'פרויקטים',
    contacts: 'יצירת קשר',
    resume: 'קורות חיים',
    switchLanguage: 'החלפת שפה',
    openMenu: 'פתיחת תפריט',
    closeMenu: 'סגירת תפריט',
    skipToContent: 'דילוג לתוכן',
};

export default header;
